import { render } from "./RecruitmentTab2.vue?vue&type=template&id=179eea18&scoped=true"
import script from "./RecruitmentTab2.vue?vue&type=script&lang=js"
export * from "./RecruitmentTab2.vue?vue&type=script&lang=js"

import "./RecruitmentTab2.vue?vue&type=style&index=0&id=179eea18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179eea18"]])

export default __exports__